import type { RiskAnswer, RiskModelDefinition, ScoredCategory } from '@norvix/utils';

import { apiFetch } from './client.js';

/** Weighted risk scoring (DEV-90). */

export interface RiskModelVersion {
  id: string;
  version: number;
  definition: RiskModelDefinition;
  note: string | null;
  createdBy: string;
  createdByName: string | null;
  createdAt: string;
}

export interface RiskAssessmentRecord {
  id: string;
  modelVersion: number;
  totalHundredths: number;
  total: string;
  classification: string;
  categories: ScoredCategory[];
  comment: string | null;
  appliedToRating: boolean;
  assessedBy: string;
  assessedByName: string | null;
  assessedAt: string;
}

export const riskScoringApi = {
  model: (): Promise<{ active: RiskModelVersion | null; versions: RiskModelVersion[] }> =>
    apiFetch('/admin/risk-scoring/model'),

  saveModel: (definition: RiskModelDefinition, note: string): Promise<RiskModelVersion> =>
    apiFetch('/admin/risk-scoring/model', { method: 'PUT', body: { definition, ...(note.trim() === '' ? {} : { note }) } }),

  forCustomer: (customerId: string): Promise<{ model: RiskModelVersion | null; assessments: RiskAssessmentRecord[] }> =>
    apiFetch(`/admin/customers/${customerId}/risk-scoring`),

  assess: (
    customerId: string,
    input: { modelVersion: number; answers: RiskAnswer[]; comment: string; applyToRating: boolean },
  ): Promise<RiskAssessmentRecord> =>
    apiFetch(`/admin/customers/${customerId}/risk-scoring`, { method: 'POST', body: input }),
};
